export default <Array<Router>>[
    {
        path: '/invoice/:code/:contactNumber',
        name: 'Invoice',
        meta: { title: 'Phiếu Xuất Kho Hàng Gởi Bán Đại Lý' },
        component: () => import('../views/operation/sale-order/print-invoice.vue')
    },
    {
        path: '/invoice-transfer/:code',
        name: 'InvoiceTransfer',
        meta: { title: 'Phiếu xuất kho kiêm biên bản bàn giao' },
        component: () => import('../views/operation/sale-order/print-invoice-transfer.vue')
    },
    {
        path: '/shippinglabel/:soCode/:packageNo',
        name: 'ShippingLabel',
        meta: { title: 'ShippingLabel' },
        component: () => import('../views/operation/sale-order/print-shipping-label.vue')
    },
    {
        path: '/shipping-label-group/:groupPackageNo',
        name: 'ShippingLabelGroup',
        meta: { title: 'ShippingLabel' },
        component: () => import('../views/operation/sale-order/print-shipping-label-of-group.vue')
    },
    {
        path: '/purchaseOrder/printer/:code',
        name: 'PurchaseOrder',
        meta: { title: 'PurchaseOrder' },
        component: () => import('../views/operation/purchase-order/print-purchase-order.vue')
    },
    {
        path: '/transferorder-receipt/:id',
        name: 'Receipt',
        meta: { title: 'TransferOrderReceipt' },
        component: () => import('../views/operation/transfer-orders/transfer-order-receipt.vue')
    },
    {
        path: '/handover-customer-report/:id',
        name: 'HandoverSessionCustomerReport',
        meta: { title: 'Phiếu xuất kho kiêm biên bản bàn giao' },
        component: () => import('../views/operation/handoversessions/print-handover-customer-report.vue')
    },
    {
        path: '/handover-tpl-report/:id',
        name: 'HandoverSessionTplReport',
        meta: { title: 'Phiếu xuất kho kiêm biên bản bàn giao kiện hàng' },
        component: () => import('../views/operation/handoversessions/print-handover-tpl-report.vue')
    },
];